var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.counter > 0)?_c('div',{staticClass:"chat-counter d-flex align-center align-self-center justify-center f13 fw400 white--text rounded-circle px-1",class:{
    squareoval: _vm.counter > 99,
    primary: _vm.isNotificationsEnabled,
    'secondary darken-1': !_vm.isNotificationsEnabled,
  }},[_vm._v(" "+_vm._s(_vm.counter)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }